import { render, staticRenderFns } from "./PayMannerEdit.vue?vue&type=template&id=4ab6439d&scoped=true&"
import script from "./PayMannerEdit.vue?vue&type=script&lang=js&"
export * from "./PayMannerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab6439d",
  null
  
)

export default component.exports